import { Plugins } from '@capacitor/core'
import branch from 'branch-sdk'

import { isNative } from '@/utils/utils'

import { ITrackingDriver } from '../driver'
import { TrackingEvent } from '../enums'
import { EventName, EventPropertyMap } from '../interface'

const { BranchDeepLinks } = Plugins

export class BranchDriver implements ITrackingDriver {
  events: TrackingEvent[]

  constructor(events: TrackingEvent[]) {
    this.events = events
  }

  private async sendBranchNativeEvent<Event extends EventName>(
    eventName: Event,
    metaData?: EventPropertyMap[Event]
  ) {
    if (!BranchDeepLinks) return
    try {
      await BranchDeepLinks.sendBranchEvent({
        eventName,
        metaData,
      })
    } catch (error) {
      console.error(`Error sending branch native event: ${error}`)
    }
  }

  // https://help.branch.io/developers-hub/docs/web-advanced-features
  private sendBranchWebEvent<Event extends EventName>(
    eventName: Event,
    metaData?: EventPropertyMap[Event]
  ) {
    branch.logEvent(eventName, metaData, (error) => {
      console.error(`Error sending branch web event: ${error}`)
    })
  }

  public triggerEvent<Event extends EventName>(
    eventName: Event,
    data?: EventPropertyMap[Event]
  ) {
    return isNative()
      ? this.sendBranchNativeEvent(eventName, data)
      : this.sendBranchWebEvent(eventName, data)
  }

  public isTrackable<Event extends EventName>(eventName: Event): boolean {
    return this.events.includes(eventName as TrackingEvent)
  }
}
